<template>
  <div class="b-foot-datenschutz">
    <a href="#" @click.prevent="toggle">Datenschutz</a>
    <div :class="[{'is-active': isActive}, 'modal']">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Datenschutz</p>
        </header>
        <section class="modal-card-body">
          <div class="WordSection1">

            <strong><p>I. Name und Anschrift des Verantwortlichen</p></strong>

            <p class="MsoNormalCxSpFirst">Der Verantwortliche im Sinne der
              Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der
              Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:</p>

            <p>
              Bringe Informationstechnik GmbH<br>
              Rudolf-Link-Strasse 6<br>
              76228 Karlsruhe<br>
              Deutschland<br>
              Tel.: +49 (0) 721 942 46-0<br>
              E-Mail: dsb@bringe.com<br>
              Website: www.bringe.com<br>
            </p>

            <strong><p>II. Name und Anschrift des Datenschutzbeauftragten</p></strong>

            <p class="MsoNormalCxSpFirst">Der Datenschutzbeauftragte des Verantwortlichen ist:</p>

            <p>
              Benjamin Spallek<br>
              Creditreform Compliance Services GmbH<br>
              Hellersbergstr. 11<br>
              41460 Neuss<br>
              Deutschland<br>
              Tel.: +49 (0) 21 31 - 109 1072<br>
              E-Mail: B.Spallek@creditreform-compliance.de<br>
            </p>

            <strong><p>III. Allgemeines zur Datenverarbeitung</p></strong>

            <strong><p>1. Umfang der Verarbeitung personenbezogener Daten</p></strong>

            <p class="MsoNormalCxSpFirst">Wir verarbeiten personenbezogene Daten unserer
              Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen
              Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung
              personenbezogener Daten unserer Nutzer erfolgt regelmäßig nur nach Einwilligung
              des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine vorherige
              Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und
              die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist. </p>

            <strong><p>2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten</p></strong>

            <p class="MsoNormalCxSpFirst">Soweit wir für Verarbeitungsvorgänge
              personenbezogener Daten eine Einwilligung der betroffenen Person einholen,
              dient Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a EU-Datenschutzgrundverordnung (DSGVO)
              als Rechtsgrundlage.</p>

            <p class="MsoNormalCxSpMiddle">Bei der Verarbeitung von personenbezogenen Daten,
              die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person
              ist, erforderlich ist, dient Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO als
              Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung
              vorvertraglicher Maßnahmen erforderlich sind.</p>

            <p class="MsoNormalCxSpMiddle">Soweit eine Verarbeitung personenbezogener Daten
              zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der unser
              Unternehmen unterliegt, dient Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;c DSGVO als
              Rechtsgrundlage.</p>

            <p class="MsoNormalCxSpMiddle">Für den Fall, dass lebenswichtige Interessen der
              betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung
              personenbezogener Daten erforderlich machen, dient Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;d
              DSGVO als Rechtsgrundlage.</p>

            <p class="MsoNormalCxSpLast">Ist die Verarbeitung zur Wahrung eines berechtigten
              Interesses unseres Unternehmens oder eines Dritten erforderlich und überwiegen
              die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das
              erstgenannte Interesse nicht, so dient Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f
              DSGVO als Rechtsgrundlage für die Verarbeitung. </p>

            <strong><p>3. Datenlöschung und Speicherdauer</p></strong>

            <p class="MsoNormal">Die personenbezogenen Daten der betroffenen Person werden
              gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine
              Speicherung kann darüber hinaus erfolgen, wenn dies durch den europäischen oder
              nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder
              sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen wurde.
              Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn eine durch die
              genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit
              zur weiteren Speicherung der Daten für einen Vertragsabschluss oder eine
              Vertragserfüllung besteht.</p>

            <strong><p>IV. Bereitstellung der Website und Erstellung von Logfiles</p></strong>

            <strong><p>1. Beschreibung und Umfang der Datenverarbeitung</p></strong>

            <p class="MsoNormalCxSpFirst">Bei jedem Aufruf unserer Internetseite erfasst
              unser System automatisiert Daten und Informationen vom Computersystem des
              aufrufenden Rechners. </p>

            <p class="MsoNormalCxSpLast">Folgende Daten werden hierbei erhoben:</p>

            <p>
              • Informationen über den Browsertyp und die verwendete Version<br>
              • Das Betriebssystem des Nutzers<br>
              • Datum und Uhrzeit des Zugriffs<br>
            </p>

            <p class="MsoNormal">Die Daten werden ebenfalls in den Logfiles unseres Systems
              gespeichert. Nicht hiervon betroffen sind die IP-Adressen des Nutzers oder
              andere Daten, die die Zuordnung der Daten zu einem Nutzer ermöglichen. Eine Speicherung
              dieser Daten zusammen mit anderen personenbezogenen Daten des Nutzers findet
              nicht statt.</p>

            <strong><p>2. Rechtsgrundlage für die Datenverarbeitung</p></strong>

            <p class="MsoNormal">Rechtsgrundlage für die vorübergehende Speicherung der Daten
              ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO. </p>

            <strong><p>3. Zweck der Datenverarbeitung</p></strong>

            <p class="MsoNormalCxSpFirst">Die vorübergehende Speicherung der IP-Adresse durch
              das System ist notwendig, um eine Auslieferung der Website an den Rechner des
              Nutzers zu ermöglichen. Hierfür muss die IP-Adresse des Nutzers für die Dauer
              der Sitzung gespeichert bleiben. </p>

            <p class="MsoNormalCxSpLast">In diesen Zwecken liegt auch unser berechtigtes
              Interesse an der Datenverarbeitung nach Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f
              DSGVO.</p>

            <strong><p>4. Dauer der Speicherung</p></strong>

            <p class="MsoNormalCxSpFirst">Die Daten werden gelöscht, sobald sie für die
              Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Im Falle
              der Erfassung der Daten zur Bereitstellung der Website ist dies der Fall, wenn
              die jeweilige Sitzung beendet ist. </p>

            <strong><p>5. Widerspruchs- und Beseitigungsmöglichkeit</p></strong>

            <p class="MsoNormal">Die Erfassung der Daten zur Bereitstellung der Website und
              die Speicherung der Daten in Logfiles ist für den Betrieb der Internetseite
              zwingend erforderlich. Es besteht folglich seitens des Nutzers keine
              Widerspruchsmöglichkeit. </p>

            <strong><p>V. Verwendung von Cookies</p></strong>

            <p class="MsoNormal"><b>a) Beschreibung und Umfang der Datenverarbeitung<p></p></b></p>

            <p class="MsoNormal">Unsere Webseite verwendet Cookies. Bei Cookies handelt es
              sich um Textdateien, die im Internetbrowser bzw. vom Internetbrowser auf dem
              Computersystem des Nutzers gespeichert werden. Ruft ein Nutzer eine Website
              auf, so kann ein Cookie auf dem Betriebssystem des Nutzers gespeichert werden.
              Dieser Cookie enthält eine charakteristische Zeichenfolge, die eine eindeutige
              Identifizierung des Browsers beim erneuten Aufrufen der Website ermöglicht. </p>

            <p class="MsoNormal">Wir setzen Cookies ein, um unsere Website nutzerfreundlicher
              zu gestalten. Einige Elemente unserer Internetseite erfordern es, dass der
              aufrufende Browser auch nach einem Seitenwechsel identifiziert werden kann. Der
              Nutzer wird auf die Verwendung von Cookies hingewiesen. </p>

            <p class="MsoNormal">In den Cookies werden dabei folgende Daten gespeichert und
              übermittelt:</p>

            <p>
              • Spracheinstellungen<br>
              • CSRF-Token (Schutz gegen Missbrauch der DVA)<br>
              • Cookie-Accept durch User<br>
            </p>

            <p class="MsoNormal"><b>b) Rechtsgrundlage für die Datenverarbeitung <p></p></b></p>

            <p class="MsoNormal">Die Rechtsgrundlage für die Verarbeitung personenbezogener
              Daten unter Verwendung von Cookies ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f
              DSGVO.</p>

            <p class="MsoNormal"><b>c) Zweck der Datenverarbeitung<p></p></b></p>

            <p class="MsoNormal">Der Zweck der Verwendung technisch notwendiger Cookies ist,
              die Nutzung von Websites für die Nutzer zu vereinfachen. Einige Funktionen
              unserer Internetseite können ohne den Einsatz von Cookies nicht angeboten
              werden. Für diese ist es erforderlich, dass der Browser auch nach einem
              Seitenwechsel wiedererkannt wird.</p>

            <p class="MsoNormal">Für folgende Anwendungen benötigen wir Cookies:</p>

            <p>
              • Spracheinstellungen<br>
              • CSRF-Token (Schutz gegen Missbrauch der DVA)<br>
              • Cookie-Accept durch User<br>
            </p>

            <p class="MsoNormal">Die durch technisch notwendige Cookies erhobenen Nutzerdaten
              werden nicht zur Erstellung von Nutzerprofilen verwendet. In diesen Zwecken
              liegt auch unser berechtigtes Interesse in der Verarbeitung der
              personenbezogenen Daten nach Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO. </p>

            <p class="MsoNormal" style="mso-outline-level:body-text"><b>e) Dauer der
              Speicherung, Widerspruchs- und Beseitigungsmöglichkeit</b><b style="mso-bidi-font-weight:
normal"><p></p></b></p>

            <p class="MsoNormal">Cookies werden auf dem Rechner des Nutzers gespeichert und
              von diesem an unserer Seite übermittelt. Daher haben Sie als Nutzer auch die
              volle Kontrolle über die Verwendung von Cookies. Durch eine Änderung der
              Einstellungen in Ihrem Internetbrowser können Sie die Übertragung von Cookies
              deaktivieren oder einschränken. Bereits gespeicherte Cookies können jederzeit
              gelöscht werden. Dies kann auch automatisiert erfolgen. Werden Cookies für
              unsere Website deaktiviert, können möglicherweise nicht mehr alle Funktionen
              der Website vollumfänglich genutzt werden.</p>

            <strong><p>VI. Rechte der betroffenen Person</p></strong>

            <p class="MsoNormal">Werden personenbezogene Daten von Ihnen verarbeitet, sind
              Sie Betroffener i.S.d. DSGVO und es stehen Ihnen folgende Rechte gegenüber dem
              Verantwortlichen zu:</p>

            <strong><p>1. Auskunftsrecht</p></strong>

            <p class="MsoNormal">Sie können von dem Verantwortlichen eine Bestätigung darüber
              verlangen, ob personenbezogene Daten, die Sie betreffen, von uns verarbeitet
              werden. </p>

            <p class="MsoNormal">Liegt eine solche Verarbeitung vor, können Sie von dem
              Verantwortlichen über folgende Informationen Auskunft verlangen:</p>

            <p class="MsoNormal">(1)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>die Zwecke,
              zu denen die personenbezogenen Daten verarbeitet werden;</p>

            <p class="MsoNormal">(2)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>die
              Kategorien von personenbezogenen Daten, welche verarbeitet werden;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(3)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>die Empfänger bzw. die Kategorien von
              Empfängern, gegenüber denen die Sie betreffenden personenbezogenen Daten
              offengelegt wurden oder noch offengelegt werden;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(4)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>die geplante Dauer der Speicherung der
              Sie betreffenden personenbezogenen Daten oder, falls konkrete Angaben hierzu
              nicht möglich sind, Kriterien für die Festlegung der Speicherdauer;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(5)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>das Bestehen eines Rechts auf
              Berichtigung oder Löschung der Sie betreffenden personenbezogenen Daten, eines
              Rechts auf Einschränkung der Verarbeitung durch den Verantwortlichen oder eines
              Widerspruchsrechts gegen diese Verarbeitung; </p>

            <p class="MsoNormal">(6)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>das Bestehen eines
              Beschwerderechts bei einer Aufsichtsbehörde;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(7)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>alle verfügbaren Informationen über die
              Herkunft der Daten, wenn die personenbezogenen Daten nicht bei der betroffenen
              Person erhoben werden;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(8)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>das Bestehen einer automatisierten
              Entscheidungsfindung einschließlich Profiling gemäß Art.&nbsp;22 Abs.&nbsp;1
              und 4 DSGVO und – zumindest in diesen Fällen – aussagekräftige Informationen
              über die involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen
              einer derartigen Verarbeitung für die betroffene Person.</p>

            <p class="MsoNormal">Ihnen steht das Recht zu, Auskunft darüber zu verlangen, ob
              die Sie betreffenden personenbezogenen Daten in ein Drittland oder an eine
              internationale Organisation übermittelt werden. In diesem Zusammenhang können
              Sie verlangen, über die geeigneten Garantien gem. Art.&nbsp;46 DSGVO im
              Zusammenhang mit der Übermittlung unterrichtet zu Recht auf Berichtigung </p>

            <p class="MsoNormal">Sie haben ein Recht auf Berichtigung und/oder
              Vervollständigung gegenüber dem Verantwortlichen, sofern die verarbeiteten
              personenbezogenen Daten, die Sie betreffen, unrichtig oder unvollständig sind.
              Der Verantwortliche hat die Berichtigung unverzüglich vorzunehmen.</p>

            <strong><p>2. Recht auf Einschränkung der Verarbeitung</p></strong>

            <p class="MsoNormal">Unter den folgenden Voraussetzungen können Sie die
              Einschränkung der Verarbeitung der Sie betreffenden personenbezogenen Daten
              verlangen:</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(1)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>wenn Sie die Richtigkeit der Sie
              betreffenden personenbezogenen für eine Dauer bestreiten, die es dem
              Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten zu
              überprüfen;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(2)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>die Verarbeitung unrechtmäßig ist und Sie
              die Löschung der personenbezogenen Daten ablehnen und stattdessen die
              Einschränkung der Nutzung der personenbezogenen Daten verlangen;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(3)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>der Verantwortliche die personenbezogenen
              Daten für die Zwecke der Verarbeitung nicht länger benötigt, Sie diese jedoch
              zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen,
              oder</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(4)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>wenn Sie Widerspruch gegen die
              Verarbeitung gemäß Art.&nbsp;21 Abs.&nbsp;1 DSGVO eingelegt haben und noch
              nicht feststeht, ob die berechtigten Gründe des Verantwortlichen gegenüber
              Ihren Gründen überwiegen.</p>

            <p class="MsoNormal">Wurde die Verarbeitung der Sie betreffenden
              personenbezogenen Daten eingeschränkt, dürfen diese Daten – von ihrer
              Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung,
              Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte
              einer anderen natürlichen oder juristischen Person oder aus Gründen eines
              wichtigen öffentlichen Interesses der Union oder eines Mitgliedstaats
              verarbeitet werden.</p>

            <p class="MsoNormal">Wurde die Einschränkung der Verarbeitung nach den o.g.
              Voraussetzungen eingeschränkt, werden Sie von dem Verantwortlichen unterrichtet
              bevor die Einschränkung aufgehoben wird.</p>

            <strong><p>3. Recht auf Löschung</p></strong>

            <strong><p>a) Löschungspflicht</p></strong>

            <p class="MsoNormal">Sie können von dem Verantwortlichen verlangen, dass die Sie
              betreffenden personenbezogenen Daten unverzüglich gelöscht werden, und der
              Verantwortliche ist verpflichtet, diese Daten unverzüglich zu löschen, sofern
              einer der folgenden Gründe zutrifft:</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(1)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>Die Sie betreffenden personenbezogenen
              Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise
              verarbeitet wurden, nicht mehr notwendig.</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(2)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>Sie widerrufen Ihre Einwilligung, auf die
              sich die Verarbeitung gem. Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a oder Art.&nbsp;9
              Abs.&nbsp;2 lit.&nbsp;a DSGVO stützte, und es fehlt an einer anderweitigen
              Rechtsgrundlage für die Verarbeitung. </p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(3)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>Sie legen gem. Art.&nbsp;21 Abs.&nbsp;1 DSGVO
              Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen
              berechtigten Gründe für die Verarbeitung vor, oder Sie legen gem. Art.&nbsp;21 Abs.&nbsp;2
              DSGVO Widerspruch gegen die Verarbeitung ein. </p>

            <p class="MsoNormal">(4)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>Die Sie
              betreffenden personenbezogenen Daten wurden unrechtmäßig verarbeitet. </p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(5)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>Die Löschung der Sie betreffenden
              personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach
              dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der
              Verantwortliche unterliegt. </p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(6)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="mso-tab-count:1"></span>Die
              Sie betreffenden personenbezogenen Daten wurden in Bezug auf angebotene Dienste
              der Informationsgesellschaft gemäß Art.&nbsp;8 Abs.&nbsp;1 DSGVO erhoben.</p>

            <strong><p>b) Information an Dritte</p></strong>

            <p class="MsoNormal">Hat der Verantwortliche die Sie betreffenden
              personenbezogenen Daten öffentlich gemacht und ist er gem. Art.&nbsp;17 Abs.&nbsp;1
              DSGVO zu deren Löschung verpflichtet, so trifft er unter Berücksichtigung der
              verfügbaren Technologie und der Implementierungskosten angemessene Maßnahmen,
              auch technischer Art, um für die Datenverarbeitung Verantwortliche, die die
              personenbezogenen Daten verarbeiten, darüber zu informieren, dass Sie als
              betroffene Person von ihnen die Löschung aller Links zu diesen
              personenbezogenen Daten oder von Kopien oder Replikationen dieser
              personenbezogenen Daten verlangt haben. </p>

            <strong><p>c) Ausnahmen</p></strong>

            <p class="MsoNormal">Das Recht auf Löschung besteht nicht, soweit die
              Verarbeitung erforderlich ist</p>

            <p class="MsoNormal">(1)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>zur Ausübung
              des Rechts auf freie Meinungsäußerung und Information;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(2)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>zur Erfüllung einer rechtlichen
              Verpflichtung, die die Verarbeitung nach dem Recht der Union oder der
              Mitgliedstaaten, dem der Verantwortliche unterliegt, erfordert, oder zur
              Wahrnehmung einer Aufgabe, die im öffentlichen Interesse liegt oder in Ausübung
              öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(3)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>aus Gründen des öffentlichen Interesses
              im Bereich der öffentlichen Gesundheit gemäß Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;h
              und i sowie Art.&nbsp;9 Abs.&nbsp;3 DSGVO;</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(4)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>für im öffentlichen Interesse liegende
              Archivzwecke, wissenschaftliche oder historische Forschungszwecke oder für
              statistische Zwecke gem. Art.&nbsp;89 Abs.&nbsp;1 DSGVO, soweit das unter
              Abschnitt a) genannte Recht voraussichtlich die Verwirklichung der Ziele dieser
              Verarbeitung unmöglich macht oder ernsthaft beeinträchtigt, oder</p>

            <p class="MsoNormal">(5)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>zur
              Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</p>

            <strong><p>4. Recht auf Unterrichtung</p></strong>

            <p class="MsoNormal">Haben Sie das Recht auf Berichtigung, Löschung oder
              Einschränkung der Verarbeitung gegenüber dem Verantwortlichen geltend gemacht,
              ist dieser verpflichtet, allen Empfängern, denen die Sie betreffenden
              personenbezogenen Daten offengelegt wurden, diese Berichtigung oder Löschung
              der Daten oder Einschränkung der Verarbeitung mitzuteilen, es sei denn, dies
              erweist sich als unmöglich oder ist mit einem unverhältnismäßigen Aufwand
              verbunden.</p>

            <p class="MsoNormal">Ihnen steht gegenüber dem Verantwortlichen das Recht zu,
              über diese Empfänger unterrichtet zu werden.</p>

            <strong><p>5. Recht auf Datenübertragbarkeit</p></strong>

            <p class="MsoNormal">Sie haben das Recht, die Sie betreffenden personenbezogenen
              Daten, die Sie dem Verantwortlichen bereitgestellt haben, in einem
              strukturierten, gängigen und maschinenlesbaren Format zu erhalten. Außerdem
              haben Sie das Recht diese Daten einem anderen Verantwortlichen ohne Behinderung
              durch den Verantwortlichen, dem die personenbezogenen Daten bereitgestellt
              wurden, zu übermitteln, sofern</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(1)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>die Verarbeitung auf einer Einwilligung
              gem. Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a DSGVO oder Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;a
              DSGVO oder auf einem Vertrag gem. Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO
              beruht und</p>

            <p class="MsoNormal">(2)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>die
              Verarbeitung mithilfe automatisierter Verfahren erfolgt.</p>

            <p class="MsoNormal">In Ausübung dieses Rechts haben Sie ferner das Recht, zu
              erwirken, dass die Sie betreffenden personenbezogenen Daten direkt von einem
              Verantwortlichen einem anderen Verantwortlichen übermittelt werden, soweit dies
              technisch machbar ist. Freiheiten und Rechte anderer Personen dürfen hierdurch
              nicht beeinträchtigt werden.</p>

            <p class="MsoNormal">Das Recht auf Datenübertragbarkeit gilt nicht für eine
              Verarbeitung personenbezogener Daten, die für die Wahrnehmung einer Aufgabe
              erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung
              öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde.</p>

            <strong><p>6. Widerspruchsrecht</p></strong>

            <p class="MsoNormal">Sie haben das Recht, aus Gründen, die sich aus ihrer
              besonderen Situation ergeben, jederzeit gegen die Verarbeitung der Sie
              betreffenden personenbezogenen Daten, die aufgrund von Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;e
              oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf diese
              Bestimmungen gestütztes Profiling. </p>

            <p class="MsoNormal">Der Verantwortliche verarbeitet die Sie betreffenden
              personenbezogenen Daten nicht mehr, es sei denn, er kann zwingende
              schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen,
              Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der
              Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</p>

            <p class="MsoNormal">Werden die Sie betreffenden personenbezogenen Daten
              verarbeitet, um Direktwerbung zu betreiben, haben Sie das Recht, jederzeit
              Widerspruch gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten
              zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das Profiling,
              soweit es mit solcher Direktwerbung in Verbindung steht.</p>

            <p class="MsoNormal">Widersprechen Sie der Verarbeitung für Zwecke der
              Direktwerbung, so werden die Sie betreffenden personenbezogenen Daten nicht
              mehr für diese Zwecke verarbeitet.</p>

            <p class="MsoNormal">Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung
              von Diensten der Informationsgesellschaft – ungeachtet der Richtlinie
              2002/58/EG – Ihr Widerspruchsrecht mittels automatisierter Verfahren auszuüben,
              bei denen technische Spezifikationen verwendet werden.</p>

            <strong><p>7. Recht auf Widerruf der datenschutzrechtlichen
              Einwilligungserklärung</p></strong>

            <p class="MsoNormal">Sie haben das Recht, Ihre datenschutzrechtliche
              Einwilligungserklärung jederzeit zu widerrufen. Durch den Widerruf der
              Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum
              Widerruf erfolgten Verarbeitung nicht berührt.</p>

            <strong><p>8. Automatisierte Entscheidung im Einzelfall
              einschließlich Profiling</p></strong>

            <p class="MsoNormal">Sie haben das Recht, nicht einer ausschließlich auf einer
              automatisierten Verarbeitung – einschließlich Profiling – beruhenden
              Entscheidung unterworfen zu werden, die Ihnen gegenüber rechtliche Wirkung
              entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt. Dies gilt
              nicht, wenn die Entscheidung </p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(1)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>für den Abschluss oder die Erfüllung
              eines Vertrags zwischen Ihnen und dem Verantwortlichen erforderlich ist,</p>

            <p class="MsoNormal" style="margin-left:35.25pt;text-indent:-35.25pt">(2)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>aufgrund von Rechtsvorschriften der Union
              oder der Mitgliedstaaten, denen der Verantwortliche unterliegt, zulässig ist
              und diese Rechtsvorschriften angemessene Maßnahmen zur Wahrung Ihrer Rechte und
              Freiheiten sowie Ihrer berechtigten Interessen enthalten oder</p>

            <p class="MsoNormal">(3)<span style="mso-tab-count:1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>mit Ihrer
              ausdrücklichen Einwilligung erfolgt.</p>

            <p class="MsoNormal">Allerdings dürfen diese Entscheidungen nicht auf besonderen
              Kategorien personenbezogener Daten nach Art.&nbsp;9 Abs.&nbsp;1 DSGVO beruhen,
              sofern nicht Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;a oder g DSGVO gilt und
              angemessene Maßnahmen zum Schutz der Rechte und Freiheiten sowie Ihrer berechtigten
              Interessen getroffen wurden.</p>

            <p class="MsoNormal">Hinsichtlich der in (1) und (3) genannten Fälle trifft der
              Verantwortliche angemessene Maßnahmen, um die Rechte und Freiheiten sowie Ihre
              berechtigten Interessen zu wahren, wozu mindestens das Recht auf Erwirkung des
              Eingreifens einer Person seitens des Verantwortlichen, auf Darlegung des
              eigenen Standpunkts und auf Anfechtung der Entscheidung gehört.</p>

            <strong><p>9. Recht auf Beschwerde bei einer Aufsichtsbehörde</p></strong>

            <p class="MsoNormal">Unbeschadet eines anderweitigen verwaltungsrechtlichen oder
              gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer
              Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts,
              ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, zu, wenn Sie der
              Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen
              Daten gegen die DSGVO verstößt. </p>

            <p class="MsoNormal">Die Aufsichtsbehörde, bei der die Beschwerde eingereicht
              wurde, unterrichtet den Beschwerdeführer über den Stand und die Ergebnisse der
              Beschwerde einschließlich der Möglichkeit eines gerichtlichen Rechtsbehelfs
              nach Art.&nbsp;78 DSGVO.</p>

          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="close">Schliessen</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BFootDatenschutz',
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
    close() {
      this.isActive = false;
    },
  },
}
</script>

<style lang="scss" scoped>
  .b-foot-datenschutz {
    display: inline;
    text-align: left;
    .modal-card-body {
      .MsoNormalCxSpFirst,
      .MsoNormalCxSpFirst,
      .MsoNormal {
        padding: .5em 0 .5em 0;
      }
      strong {
        p {
          padding: .5em 0 .5em 0;
        }
      }
    }
  }
</style>
